<template>
  <div class="description">
    <th>{{ th }}</th>
    <td>
      <slot name="td"></slot>
    </td>
  </div>
</template>

<script>
export default {
  name: "ConfirmRow",
  props: {
    th: {
      type: String,
      require: true,
    },
  },
  setup() {},
};
</script>

<style lang="scss" scoped>
.description {
  color: black;
  padding: 10px 0;
  font-weight: bold;
  border-bottom: 1px solid #e2e2e2;
  th {
    width: 25%;
    display: inline-block;
    color: #8d8d8d;
    font-weight: 100;
  }
  td {
    width: 75%;
    font-weight: bold;
    color: #000000;
    display: inline-block;
  }
}
</style>
